module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/highlight.js/lib/languages/plaintext.js
// module id = 603
// module chunks = 0